import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconPin({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} fill-rule="evenodd" d="M.751 4.364a2.571 2.571 0 0 1 3.633 0l7.252 7.252a2.572 2.572 0 0 1 0 3.633 2.571 2.571 0 0 1-3.633 0l-3.26-3.263-3.862 3.863a.516.516 0 0 1-.773-.681l.043-.05 3.862-3.862-3.26-3.263a2.566 2.566 0 0 1-.127-3.495l.125-.134zm2.903.73a1.533 1.533 0 1 0-2.173 2.168l7.252 7.257a1.54 1.54 0 0 0 2.173 0 1.54 1.54 0 0 0 0-2.173L3.654 5.094zM12.26.662l.093.088 2.897 2.897c.97.97 1 2.53.088 3.535l-.088.092-2.897 2.897a.516.516 0 0 1-.773-.68l.043-.05 2.897-2.897a1.536 1.536 0 0 0 .069-2.093l-.069-.074-2.897-2.897a1.536 1.536 0 0 0-2.094-.069l-.073.069-1.043 1.042 2.79 2.79a.516.516 0 0 1-.68.773l-.05-.043-2.79-2.791-1.124 1.126a.516.516 0 0 1-.773-.681l.043-.049L8.726.75c.97-.97 2.529-1 3.534-.088z"/>
        </svg>

    );
}

export default IconPin;

